import React from "react";
import "../CommercialAirlineHome.css";

const CardComponent = ({ item, onClickCard }) => {
  return (
    <div className="commercial-airline-card" onClick={onClickCard}>
      <img
        src={item.icon}
        alt={item.title}
        width={item.width}
        height={item.height}
        className="commercial-airline-card-icon"
      />
      <p>{item.title}</p>
    </div>
  );
};

export default CardComponent;
